import { API_URL } from '../constants/index'
import { getRequest, postRequest, getcontractIdNumber, deleteRequest } from './api'

export async function list(size, index, containsValues, orderByValues) {
  containsValues = containsValues || '%20'
  orderByValues = orderByValues || '%20'
  if (!containsValues.includes('ContractID')) {
    containsValues = `${containsValues}, ContractID:${getcontractIdNumber()},`
  }

  const url = new URL(`${API_URL}invoice2`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  if (size !== null && size !== undefined) {
    searchParams.append('size', parseInt(size, 10) || 15)
  }

  if (index !== null && index !== undefined) {
    searchParams.append('index', parseInt(index, 10) || 0)
  }

  if (containsValues !== null && containsValues !== undefined) {
    searchParams.append('containsValues', containsValues)
  }

  if (orderByValues !== null && orderByValues !== undefined) {
    searchParams.append('orderByValues', orderByValues)
  }

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function find(id) {
  return getRequest(`${API_URL}invoice2/${id}`)
}

export async function save(values) {
  return postRequest(`${API_URL}invoice2`, values)
}

export async function addWorkOrdersToInvoice(values) {
  console.log('addWorkOrdersToInvoice', values)
  return postRequest(`${API_URL}invoice2WorkOrder/addWorkOrdersToInvoice`, values)
}

export function remove(id) {
  return deleteRequest(`${API_URL}invoice2/${id}`)
}

export async function createInvoice() {
  const id = getcontractIdNumber()
  const values = {
    values: {
      contractID: id,
    },
  }
  return postRequest(`${API_URL}invoice2/byContractID`, values)
}

export async function createInvoiceByWorkOrderID(id) {
  const values = {
    values: {
      workOrderID: id,
    },
  }
  return postRequest(`${API_URL}invoice2/byWorkOrderID`, values)
}
